import dynamic from "next/dynamic";
import { parcelServicesSchema } from "@/validations/parcel/parcelSteps.validation";
import {
  parcelDetailsSchemaUz,
  parcelItemsSchemaUz,
} from "@/validations/parcel/parcelStepsUz.validation";

const ParcelDetailsUz = dynamic(
  () =>
    import(
      "@/components/dashboard/parcels/modal/parcel-form-components/uz/parcel-details-uz"
    ),
  { ssr: false },
);
const ParcelItemsUz = dynamic(
  () =>
    import(
      "@/components/dashboard/parcels/modal/parcel-form-components/uz/parcel-items-uz"
    ),
  { ssr: false },
);

const ParcelServices = dynamic(
  () =>
    import(
      "@/components/dashboard/parcels/modal/parcel-form-components/parcel-services"
    ),
  { ssr: false },
);

export const getParcelUz = [
  //* Note: Removed before there's "Send Parcel" too
  // {
  //   stepName: "add_parcel",
  //   component: <ShippingMethod />,
  //   validationSchema: parcelShippingMethodSchema,
  // },
  {
    stepName: "parcel_details",
    component: <ParcelDetailsUz />,
    validationSchema: parcelDetailsSchemaUz,
  },
  {
    stepName: "item_details",
    component: <ParcelItemsUz />,
    validationSchema: parcelItemsSchemaUz,
  },
  {
    stepName: "addon_services",
    component: <ParcelServices />,
    validationSchema: parcelServicesSchema,
  },
];
